export default "__VITE_ASSET__Qhu5UdGL__"